import { render } from "./Donut.vue?vue&type=template&id=1b04da0a&lang=pug"
import script from "./Donut.vue?vue&type=script&lang=js"
export * from "./Donut.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__